import React from "react";
import { CollapsableHeader } from "../header";
import {
  Box,
  Stack,
  Grid2 as Grid,
  useMediaQuery,
} from "@mui/material";
import { HorizontalPosition, VerticalPosition } from "../../../utils";
import { SelectBoxOption } from "../../../interfaces";
import { HighlightSelectBox } from "../../highLightSelectBox";
import {
  Alignment,
  PositionError,
} from "../../../redux/slices/documentTemplate";

export interface BrandingProps {
  alignment: Alignment;
  onPositionChange: (position: SelectBoxOption, key: keyof Alignment) => void;
}

export const Branding: React.FC<{
  title: string;
  sideNote: BrandingProps;
  error: PositionError;
}> = (props) => {
  const isMatch = useMediaQuery("(max-width:1530px)");

  const { alignment } = props.sideNote;

  return (
    (<CollapsableHeader
        title={props.title}
        showIcon={true}
        isExpanded={true}
      >
      <Box sx={{
        p: 1
      }}>
        <Stack spacing={1}>
          <Grid
            container
            columns={isMatch ? 12 : 13}
            sx={{
              columnGap: isMatch ? 0 : 1,
              justifyContent: "space-between"
            }}>
            <Grid
              size={{
                xs: 12,
                sm: 12,
                md: 12,
                xl: 6
              }}>
              <HighlightSelectBox
                options={HorizontalPosition}
                label={"Horizontal Position"}
                onChange={(position: SelectBoxOption) =>
                  props.sideNote.onPositionChange(position, "horizontal")
                }
                value={alignment.horizontal}
                error={props.error.xPositionError}
                helperText={
                  props.error.xPositionError
                    ? "Please select the horizontal position"
                    : ""
                }
              />
            </Grid>
            <Grid
              size={{
                xs: 12,
                sm: 12,
                md: 12,
                xl: 6
              }}>
              <HighlightSelectBox
                options={VerticalPosition}
                label={"Vertical Position"}
                onChange={(position: SelectBoxOption) =>
                  props.sideNote.onPositionChange(position, "vertical")
                }
                value={alignment.vertical}
                error={props.error.yPositionError}
                helperText={
                  props.error.yPositionError
                    ? "Please select the vertical position"
                    : ""
                }
              />
            </Grid>
          </Grid>
        </Stack>
      </Box>
    </CollapsableHeader>)
  );
};
